import { el, clear, fmtDataHora, fmtDecorrido, norm, formatarNome, mascararMatricula, rotuloDocumento, empresaCurta, limpavel } from '../lib/dom.js';
import { loader } from '../ui/loader.js';
import { toast } from '../lib/toast.js';
import { abrirModal } from '../ui/modal.js';
import { operadorAtual } from '../lib/operador.js';
import { ehGestor } from '../lib/auth.js';
import { podeAcessar } from '../lib/permissoes.js';
import { ir } from '../lib/router.js';
import { listarChavesComStatus, buscarColaboradores, registrarMovimentacao, listarMotivos, chavesRecentesDoColaborador } from '../domain/movimentacao.js';
import { buscaSelect } from '../ui/buscaSelect.js';
import { sugerirCriarChave, sugerirCancelarChave } from '../domain/sugestoes.js';
import { registrarAcao, registrarResultado } from '../lib/uso.js';
import { assinarTabela, pollPeriodico } from '../lib/realtime.js';

const ehOutroDia = (iso) => iso && new Date(iso).toDateString() !== new Date().toDateString();
const semOperador = () => {
  if (operadorAtual.id || operadorAtual.ehLogin) return false;
  toast('Selecione o operador no topo (canto superior direito) antes de registrar.', 'erro');
  return true;
};

// Observa o fechamento de QUALQUER modal para devolver o foco a busca. Um por vez.
let _obsModal = null;
function mapResultado(t) { if (t === 'conflito') return 'erro_conflito'; if (t === 'rede') return 'erro_rede'; return 'erro_outro'; }

function iconeEmprestar() {
  return el('span', { class: 'acao-ic' }, [
    el('i', { class: 'ph ph-key' }),
    el('span', { class: 'acao-selo acao-selo--disp' }, [el('i', { class: 'ph ph-arrow-up' })]),
  ]);
}
function iconeDevolver() {
  return el('span', { class: 'acao-ic' }, [
    el('i', { class: 'ph ph-key' }),
    el('span', { class: 'acao-selo acao-selo--emp' }, [el('i', { class: 'ph ph-arrow-down' })]),
  ]);
}

/** Tela de Movimentação em cartões. Exige operador selecionado (atribuição). */
export const paginaMovimentacao = {
  async render(container) {
    container.innerHTML = '';
    const estado = { filtro: 'TODOS', termo: '', chaves: [], visiveis: [], motivos: [], colabIds: null, colabNome: '', colabOrdem: [], colab: null };

    container.append(
      el('h1', { class: 'view__titulo', text: 'Registrar Movimentação' }),
      el('p', { class: 'view__sub', text: 'Empreste (verde) ou devolva (vermelho). Busque pela chave ou por quem está com ela.' }),
    );

    const rotulos = { TODOS: 'Todos', RETIRADA: 'Emprestado', DISPONIVEL: 'Disponível' };
    const cont = {};
    const radios = Object.keys(rotulos).map((f) => {
      const span = el('span', { class: 'mov-filtro__cont', text: '0' });
      cont[f] = span;
      return el('label', { class: 'mov-filtro' }, [
        el('input', { type: 'radio', name: 'filtro', checked: f === 'TODOS' ? '' : null,
          onChange: () => { estado.filtro = f; pintar(); busca.focus(); } }),
        ' ' + rotulos[f] + ' ', span,
      ]);
    });

    const busca = el('input', { type: 'text', class: 'mov-busca', placeholder: 'Buscar chave ou quem está com ela…' });
    const limpar = el('button', { type: 'button', class: 'mov-busca__x', title: 'Limpar busca', 'aria-label': 'Limpar busca',
      onClick: () => { limparBuscaTudo(); busca.focus(); } },
      [el('i', { class: 'ph ph-x' })]);
    limpar.style.display = 'none';
    let sugTimer = null;
    busca.addEventListener('input', () => {
      if (estado.colabIds) sairDoFiltroColab();
      estado.termo = norm(busca.value);
      limpar.style.display = busca.value ? '' : 'none';
      pintar();
      clearTimeout(sugTimer);
      const t = busca.value.trim();
      if (t.length < 2) { buscaSug.style.display = 'none'; return; }
      sugTimer = setTimeout(async () => {
        const ops = await buscarColaboradores(t);
        if (busca.value.trim() !== t) return;
        montarSug(ops);
      }, 250);
    });
    busca.addEventListener('blur', () => setTimeout(() => { buscaSug.style.display = 'none'; }, 150));
    busca.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const t = busca.value.trim();
        let alvo = null;
        // Leitor de codigo de barras / numero EXATO da chave: age direto nela (independe do filtro).
        if (t) {
          const exato = estado.chaves.filter((c) => String(c.numero).trim().toLowerCase() === t.toLowerCase());
          if (exato.length === 1) alvo = exato[0];
        }
        if (!alvo && estado.visiveis.length === 1) alvo = estado.visiveis[0];
        if (alvo) { if (alvo.situacao === 'DISPONIVEL') emprestar(alvo); else devolver(alvo); }
      } else if (e.key === 'Escape') { limparBuscaTudo(); }
    });
    const buscaSug = el('div', { class: 'mov-busca-sug', style: 'display:none' });
    const buscaWrap = el('div', { class: 'mov-busca-wrap' }, [busca, limpar, buscaSug]);
    function sairDoFiltroColab() { estado.colab = null; estado.colabIds = null; estado.colabOrdem = []; estado.colabNome = ''; }
    function limparBuscaTudo() { sairDoFiltroColab(); busca.value = ''; estado.termo = ''; limpar.style.display = 'none'; buscaSug.style.display = 'none'; pintar(); }

    // Cursor volta para a busca sempre que se retorna a tela (foco adiado p/ depois do modal fechar).
    function focarBusca() { setTimeout(() => { try { busca.focus(); } catch (e) { /* ignore */ } }, 40); }
    if (_obsModal) _obsModal.disconnect();
    _obsModal = new MutationObserver((muts) => {
      if (!document.body.contains(busca)) { if (_obsModal) _obsModal.disconnect(); _obsModal = null; return; }
      for (const m of muts) for (const n of m.removedNodes) {
        if (n.nodeType === 1 && n.classList && n.classList.contains('modal-bg')) { focarBusca(); return; }
      }
    });
    _obsModal.observe(document.body, { childList: true });

    const grid = el('div', { class: 'mov-grid' });
    const colabBanner = el('div', { class: 'mov-colab-banner', style: 'display:none' });
    container.append(
      el('div', { class: 'mov-toolbar' }, [el('div', { class: 'mov-filtros' }, radios), buscaWrap]),
      colabBanner,
      grid,
    );

    function montarSug(ops) {
      clear(buscaSug);
      if (!ops.length) { buscaSug.style.display = 'none'; return; }
      buscaSug.append(el('div', { class: 'mov-busca-sug__tit', text: 'Ver chaves que a pessoa pegou (últimos 6 meses):' }));
      ops.slice(0, 6).forEach((c) => {
        buscaSug.append(el('div', { class: 'mov-busca-sug__item', onMousedown: (e) => { e.preventDefault(); aplicarColabFiltro(c); } },
          [el('i', { class: 'ph ph-clock-user' }), el('span', { text: `${formatarNome(c.nome)}${c.empregador?.empresa ? ' · ' + empresaCurta(c.empregador.empresa) : ''} · ${rotuloDocumento(c)}` })]));
      });
      buscaSug.style.display = 'block';
    }

    async function aplicarColabFiltro(c) {
      buscaSug.style.display = 'none';
      const ids = await chavesRecentesDoColaborador(c.id);
      if (!ids.length) { toast(`${formatarNome(c.nome)} não pegou chave nos últimos 6 meses.`, 'info'); return; }
      estado.colab = c;
      estado.colabIds = new Set(ids);
      estado.colabOrdem = ids;
      estado.colabNome = formatarNome(c.nome);
      estado.filtro = 'TODOS';
      radios[0].querySelector('input').checked = true;
      estado.termo = ''; busca.value = estado.colabNome; limpar.style.display = '';
      pintar();
    }

    function atualizarContadores() {
      const total = estado.chaves.length;
      const emp = estado.chaves.filter((c) => c.situacao === 'RETIRADA').length;
      cont.TODOS.textContent = total;
      cont.RETIRADA.textContent = emp;
      cont.DISPONIVEL.textContent = total - emp;
      cont.RETIRADA.classList.toggle('mov-filtro__cont--alerta', emp > 0);
    }

    async function carregar() {
      clear(grid).append(loader());
      try {
        estado.chaves = await listarChavesComStatus();
      } catch {
        clear(grid).append(el('div', { class: 'mov-aviso' }, [
          el('p', { text: 'Não foi possível carregar as chaves (verifique a conexão / migração).' }),
          el('button', { class: 'btn btn--primario', onClick: carregar }, 'Recarregar'),
        ]));
        return;
      }
      atualizarContadores();
      pintar();
      focarBusca();
    }

    async function recarregarSilencioso() {
      try { estado.chaves = await listarChavesComStatus(); } catch { return; }
      atualizarContadores();
      pintar();
    }

    function pintar() {
      let lista = estado.chaves;
      if (estado.colabIds) {
        lista = lista.filter((c) => estado.colabIds.has(c.id));
      }
      colabBanner.style.display = 'none';
      if (estado.filtro !== 'TODOS') lista = lista.filter((c) => c.situacao === estado.filtro);
      if (estado.termo && !estado.colabIds) {
        const tokens = estado.termo.split(/\s+/).filter(Boolean);
        lista = lista.filter((c) => {
          const alvo = norm([c.descricao, c.numero, c.colaborador?.nome, c.colaborador?.matricula, c.portador_avulso].filter(Boolean).join(' '));
          return tokens.every((t) => alvo.includes(t));
        });
      }
      if (estado.colabIds) {
        const ordem = estado.colabOrdem;
        lista = [...lista].sort((a, b) => ordem.indexOf(a.id) - ordem.indexOf(b.id));
      } else {
        lista = [...lista].sort((a, b) => {
          if (a.situacao !== b.situacao) return a.situacao === 'RETIRADA' ? -1 : 1;
          if (a.situacao === 'RETIRADA') return new Date(a.emprestada_em || 0) - new Date(b.emprestada_em || 0);
          return (a.descricao || '').localeCompare(b.descricao || '');
        });
      }
      estado.visiveis = lista;
      clear(grid);
      if (!lista.length) { grid.append(el('p', { class: 'mov-aviso', text: estado.colabIds ? 'Nenhuma dessas chaves no filtro atual.' : 'Nenhuma chave encontrada.' })); return; }
      for (const c of lista) grid.append(cartao(c));
    }

    function cartao(chave) {
      const titulo = chave.descricao || `Chave ${chave.numero}`;
      const tituloEl = el('span', { class: 'chave-card__titulo', text: titulo, title: titulo });
      const numEl = el('span', { class: 'chave-card__num' }, [el('i', { class: 'ph ph-key' }), ' nº ' + chave.numero]);

      if (chave.situacao === 'DISPONIVEL') {
        const txt = chave.ultima_devolucao_em
          ? `Deixada por ${formatarNome(chave.ultima_devolucao_por) || '—'} · ${fmtDataHora(chave.ultima_devolucao_em)}`
          : null;
        const hist = txt
          ? el('div', { class: 'chave-card__hist', title: fmtDecorrido(chave.ultima_devolucao_em) },
              [el('i', { class: 'ph ph-sign-in' }), el('span', { text: txt, title: txt })])
          : el('div', { class: 'chave-card__hist chave-card__hist--vazio' },
              [el('i', { class: 'ph ph-clock-counter-clockwise' }), el('span', { text: 'Sem histórico de empréstimo' })]);
        return el('div', { class: 'chave-card chave-card--disp' }, [
          el('div', { class: 'chave-card__topo' }, [tituloEl, numEl]),
          el('div', { class: 'chave-card__corpo' }, [hist]),
          el('button', { class: 'chave-card__acao chave-card__acao--disp', title: 'Pegar chave', 'aria-label': 'Pegar chave', onClick: () => emprestar(chave) },
            [iconeEmprestar()]),
        ]);
      }

      const colab = chave.colaborador;
      const nomeHolder = colab?.nome ? formatarNome(colab.nome) : (chave.portador_avulso ? formatarNome(chave.portador_avulso) : 'Não informado');
      const avulso = !colab && !!chave.portador_avulso;
      const outroDia = ehOutroDia(chave.emprestada_em);
      const dir = el('span', { class: 'chave-card__topo-dir' }, [
        outroDia ? el('i', { class: 'ph ph-warning chave-card__destaque', title: 'Emprestada em outro dia' }) : null,
        numEl,
      ]);
      return el('div', { class: 'chave-card chave-card--emp' + (outroDia ? ' chave-card--atraso' : '') }, [
        el('div', { class: 'chave-card__topo' }, [tituloEl, dir]),
        el('div', { class: 'chave-card__corpo' }, [
          el('div', { class: 'chave-card__info' }, [
            el('i', { class: 'ph ph-user' }),
            el('span', { text: nomeHolder + (avulso ? ' · avulso' : ''), title: nomeHolder }),
            el('button', { class: 'chave-card__editar', title: 'Corrigir quem está com a chave', 'aria-label': 'Corrigir portador', onClick: () => emprestar(chave, true) }, [el('i', { class: 'ph ph-pencil-simple' })]),
          ]),
          colab ? linhaInfo('ph-identification-badge', `Matrícula ${mascararMatricula(colab.matricula)}`) : null,
          linhaInfo('ph-clock', chave.emprestada_em ? fmtDataHora(chave.emprestada_em) : '—',
            chave.emprestada_em ? fmtDecorrido(chave.emprestada_em) : ''),
        ]),
        el('div', { class: 'chave-card__rodape' }, [
          chave.ultima_retirada_operador
            ? el('span', { class: 'chave-card__rodape-op', title: 'Entregue por ' + formatarNome(chave.ultima_retirada_operador) },
                [el('i', { class: 'ph ph-clock-user' }), el('span', { text: 'Entregue por ' + formatarNome(chave.ultima_retirada_operador) })])
            : el('span', { class: 'chave-card__rodape-op' }),
          el('button', { class: 'chave-card__acao chave-card__acao--emp', title: 'Devolver chave', 'aria-label': 'Devolver chave', onClick: () => devolver(chave) },
            [iconeDevolver()]),
        ]),
      ]);
    }

    function linhaInfo(icone, texto, title) {
      return el('div', { class: 'chave-card__info', title: title || null },
        [el('i', { class: `ph ${icone}` }), el('span', { text: texto, title: texto })]);
    }

    function sugerirChave() {
      let tipo = 'CRIAR';
      const descricao = el('input', { type: 'text', placeholder: 'Descrição (setor/sala)' });
      const motivo = el('textarea', { rows: '2', placeholder: 'Motivo da sugestão' });
      const opc = estado.chaves.map((c) => ({ value: c.id, label: `${c.numero}${c.descricao ? ' — ' + c.descricao : ''}` }));
      const picker = buscaSelect({ opcoes: opc, valor: null, label: '' });
      const campoDesc = el('div', { class: 'campo' }, [el('label', { text: 'Descrição (setor/sala) *' }), descricao]);
      const campoChave = el('div', { class: 'campo', style: 'display:none' }, [el('label', { text: 'Chave a cancelar *' }), picker.elemento]);
      const radio = (v, label) => el('label', { class: 'mov-filtro' }, [
        el('input', { type: 'radio', name: 'sugtipo', checked: v === 'CRIAR' ? '' : null, onChange: () => {
          tipo = v; const criar = v === 'CRIAR';
          campoDesc.style.display = criar ? '' : 'none';
          campoChave.style.display = criar ? 'none' : '';
        } }),
        ' ' + label,
      ]);
      abrirModal({
        titulo: 'Sugerir chave',
        corpo: [
          el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Sua sugestão vai para o gestor aprovar. O número é gerado pelo sistema.' }),
          el('div', { class: 'mov-filtros', style: 'margin: 8px 0 16px; gap: 20px' }, [radio('CRIAR', 'Criar nova'), radio('CANCELAR', 'Cancelar existente')]),
          campoDesc, campoChave,
          el('div', { class: 'campo' }, [el('label', { text: 'Motivo *' }), motivo]),
        ],
        acoes: [
          { rotulo: 'Cancelar', classe: 'btn' },
          { rotulo: 'Enviar sugestão', classe: 'btn btn--primario', onClick: async () => {
            if (!motivo.value.trim()) { toast('Informe o motivo.', 'erro'); return false; }
            if (tipo === 'CRIAR') {
              if (!descricao.value.trim()) { toast('Descreva a chave (setor/sala).', 'erro'); return false; }
              const { erro } = await sugerirCriarChave(descricao.value.trim(), motivo.value.trim());
              if (erro) { toast('Não foi possível enviar: ' + erro, 'erro'); return false; }
            } else {
              const id = picker.getValue();
              if (!id) { toast('Escolha a chave a cancelar.', 'erro'); return false; }
              const { erro } = await sugerirCancelarChave(id, motivo.value.trim());
              if (erro) { toast('Não foi possível enviar: ' + erro, 'erro'); return false; }
            }
            toast('Sugestão enviada ao gestor.', 'sucesso');
            return true;
          } },
        ],
      });
    }

    function exigeObsCadastro(id) { const mt = estado.motivos.find((x) => x.id === id); return !!mt && mt.nome === 'Colaborador não cadastrado'; }

    function emprestar(chave, corrigindo = false) {
      if (semOperador()) return;
      const picker = pickerColaborador(estado.colab);
      const avulsoChk = el('input', { type: 'checkbox' });
      const nomeAvulso = el('input', { type: 'text', placeholder: 'Nome de quem está pegando' });
      const naoIdentChk = el('input', { type: 'checkbox' });
      const motivoSel = el('select', {}, [
        el('option', { value: '' }, '— escolha o motivo —'),
        ...estado.motivos.map((m) => el('option', { value: m.id }, m.nome)),
      ]);
      const obs = el('textarea', { rows: '2', placeholder: 'Observação (opcional)' });

      const campoPicker = el('div', { class: 'campo' }, [el('label', { text: 'Para quem? (colaborador) *' }), picker.elemento]);
      const campoNome = el('div', { class: 'campo', style: 'display:none' }, [el('label', { text: 'Nome da pessoa *' }), limpavel(nomeAvulso)]);
      const campoMotivo = el('div', { class: 'campo', style: 'display:none' }, [el('label', { text: 'Motivo *' }), motivoSel]);
      const campoNaoIdent = el('label', { class: 'mov-avulso', style: 'display:none' }, [naoIdentChk, ' Não foi possível identificar a pessoa']);

      function atualizarAvulso() {
        const on = avulsoChk.checked;
        const mot = estado.motivos.find((m) => m.id === motivoSel.value);
        const podeNaoIdent = on && mot && mot.nome !== 'Colaborador não cadastrado';
        if (!podeNaoIdent) naoIdentChk.checked = false;
        campoPicker.style.display = on ? 'none' : '';
        campoMotivo.style.display = on ? '' : 'none';
        campoNaoIdent.style.display = podeNaoIdent ? '' : 'none';
        campoNome.style.display = (on && !naoIdentChk.checked) ? '' : 'none';
      }
      avulsoChk.addEventListener('change', () => { atualizarAvulso(); if (avulsoChk.checked && !naoIdentChk.checked) nomeAvulso.focus(); });
      motivoSel.addEventListener('change', atualizarAvulso);
      naoIdentChk.addEventListener('change', atualizarAvulso);
      async function confirmar() {
        let mov;
        if (avulsoChk.checked) {
          if (!motivoSel.value) { toast('Escolha o motivo.', 'erro'); return false; }
          if (exigeObsCadastro(motivoSel.value) && !obs.value.trim()) { toast('Motivo Colaborador não cadastrado: anote o CPF e a empresa na observação.', 'erro'); return false; }
          const nome = naoIdentChk.checked ? 'Não identificado' : nomeAvulso.value.trim();
          if (!nome) { toast('Informe o nome (ou marque "não foi possível identificar").', 'erro'); return false; }
          mov = { chave_id: chave.id, colaborador_id: null, portador_avulso: nome, motivo_id: motivoSel.value, observacao: obs.value, tipo_movimentacao: 'RETIRADA' };
        } else {
          const colab = picker.getSelecionado();
          if (!colab) { toast('Selecione o colaborador (ou marque "avulso").', 'erro'); return false; }
          if (colab.acesso_suspenso) { toast(`${formatarNome(colab.nome)} está com acesso suspenso como colaborador (afastado temporariamente) e não está autorizado a retirar chave.`, 'erro'); return false; }
          mov = { chave_id: chave.id, colaborador_id: colab.id, observacao: obs.value, tipo_movimentacao: 'RETIRADA' };
        }
        if (corrigindo) {
          mov.observacao = ('Correção de portador. ' + (mov.observacao || '')).trim();
          const dev = await registrarMovimentacao({ chave_id: chave.id, colaborador_id: chave.colaborador_atual_id, devolvido_por: chave.colaborador?.nome || chave.portador_avulso || null, tipo_movimentacao: 'DEVOLUCAO', observacao: 'Correção de portador (registro substituído)' });
          if (dev.erro) { toast('Não foi possível corrigir: ' + dev.erro, 'erro'); await carregar(); return false; }
        }
        const { erro, tipo } = await registrarMovimentacao(mov);
        if (erro) { registrarResultado('chaves', 'emprestar_clicou', mapResultado(tipo)); toast(erro, 'erro'); if (tipo === 'conflito') { await carregar(); return true; } return false; }
        if (corrigindo) { toast('Correção registrada!', 'sucesso'); await carregar(); return true; }
        const inverso = { chave_id: chave.id, colaborador_id: mov.colaborador_id, tipo_movimentacao: 'DEVOLUCAO', observacao: 'Estorno (desfazer empréstimo)' };
        registrarAcao('chaves', 'emprestar_clicou', 'chave'); registrarResultado('chaves', 'emprestar_clicou', 'ok');
        toast('Chave emprestada!', 'sucesso', { rotulo: 'Desfazer', ttl: 7000, onAcao: () => desfazer(inverso) });
        await carregar();
        return true;
      }
      const acoes = [
        { rotulo: 'Cancelar', classe: 'btn' },
        { rotulo: corrigindo ? 'Salvar correção' : 'Confirmar empréstimo', classe: 'btn btn--primario', onClick: confirmar },
      ];
      abrirModal({
        titulo: corrigindo ? `Corrigir quem está com: ${chave.descricao || 'Chave ' + chave.numero}` : `Emprestar: ${chave.descricao || 'Chave ' + chave.numero}`,
        corpo: [
          campoPicker,
          el('label', { class: 'mov-avulso' }, [avulsoChk, ' Entrega avulsa']),
          campoMotivo, campoNaoIdent, campoNome,
          el('div', { class: 'campo' }, [el('label', { text: 'Observação' }), obs]),
        ],
        acoes,
      });
    }

    function devolver(chave) {
      if (semOperador()) return;
      const obs = el('textarea', { rows: '2', placeholder: 'Observação (opcional)' });
      const colabId = chave.colaborador_atual_id;
      const portadorAntes = colabId ? null : chave.portador_avulso;
      const quem = chave.colaborador?.nome ? formatarNome(chave.colaborador.nome) : (chave.portador_avulso ? formatarNome(chave.portador_avulso) : '');
      const quemDisplay = quem || 'colaborador não informado';
      const picker = pickerColaborador(estado.colab);
      const avulsoChk = el('input', { type: 'checkbox' });
      const nomeAvulso = el('input', { type: 'text', placeholder: 'Nome de quem está devolvendo' });
      const naoIdentChk = el('input', { type: 'checkbox' });
      const campoPicker = el('div', { class: 'campo' }, [el('label', { text: 'Quem está devolvendo (último a sair) *' }), picker.elemento]);
      const notaQuem = el('p', { class: 'mov-nota-discreta', text: 'Esta chave está com ' + quemDisplay + (chave.emprestada_em ? ' desde ' + fmtDataHora(chave.emprestada_em) : '') + '.' });
      const motivoSel = el('select', {}, [
        el('option', { value: '' }, '— escolha o motivo —'),
        ...estado.motivos.map((mt) => el('option', { value: mt.id }, mt.nome)),
      ]);
      const campoMotivo = el('div', { class: 'campo', style: 'display:none' }, [el('label', { text: 'Motivo *' }), motivoSel]);
      const campoNome = el('div', { class: 'campo', style: 'display:none' }, [el('label', { text: 'Nome da pessoa *' }), limpavel(nomeAvulso)]);
      const campoNaoIdent = el('label', { class: 'mov-avulso', style: 'display:none' }, [naoIdentChk, ' Não foi possível identificar a pessoa']);
      function atualizarAvulso() {
        const on = avulsoChk.checked;
        const mot = estado.motivos.find((m) => m.id === motivoSel.value);
        const podeNaoIdent = on && mot && mot.nome !== 'Colaborador não cadastrado';
        if (!podeNaoIdent) naoIdentChk.checked = false;
        campoPicker.style.display = on ? 'none' : '';
        campoMotivo.style.display = on ? '' : 'none';
        campoNaoIdent.style.display = podeNaoIdent ? '' : 'none';
        campoNome.style.display = (on && !naoIdentChk.checked) ? '' : 'none';
      }
      avulsoChk.addEventListener('change', () => { atualizarAvulso(); if (avulsoChk.checked && !naoIdentChk.checked) nomeAvulso.focus(); });
      motivoSel.addEventListener('change', atualizarAvulso);
      naoIdentChk.addEventListener('change', atualizarAvulso);
      abrirModal({
        titulo: `Devolver: ${chave.descricao || 'Chave ' + chave.numero}`,
        corpo: [
          campoPicker,
          el('label', { class: 'mov-avulso' }, [avulsoChk, ' Devolução avulsa']),
          campoMotivo,
          campoNaoIdent,
          campoNome,
          el('div', { class: 'campo' }, [el('label', { text: 'Observação' }), obs]),
          notaQuem,
        ],
        acoes: [
          { rotulo: 'Cancelar', classe: 'btn' },
          {
            rotulo: 'Confirmar devolução', classe: 'btn btn--primario',
            onClick: async () => {
              let nomeDev;
              if (avulsoChk.checked) {
                if (!motivoSel.value) { toast('Escolha o motivo.', 'erro'); return false; }
                if (exigeObsCadastro(motivoSel.value) && !obs.value.trim()) { toast('Motivo Colaborador não cadastrado: anote o CPF e a empresa na observação.', 'erro'); return false; }
                nomeDev = naoIdentChk.checked ? 'Não identificado' : nomeAvulso.value.trim();
                if (!nomeDev) { toast('Informe o nome (ou marque "não foi possível identificar").', 'erro'); return false; }
              } else {
                const colab = picker.getSelecionado();
                if (!colab) { toast('Selecione quem está devolvendo (ou marque "avulso").', 'erro'); return false; }
                nomeDev = formatarNome(colab.nome);
              }
              const { erro, tipo } = await registrarMovimentacao({ chave_id: chave.id, colaborador_id: colabId, tipo_movimentacao: 'DEVOLUCAO', observacao: obs.value, devolvido_por: nomeDev, motivo_id: avulsoChk.checked ? motivoSel.value : null });
              if (erro) { registrarResultado('chaves', 'devolver_clicou', mapResultado(tipo)); toast(erro, 'erro'); if (tipo === 'conflito') { await carregar(); return true; } return false; }
              const inverso = { chave_id: chave.id, colaborador_id: colabId, portador_avulso: portadorAntes, tipo_movimentacao: 'RETIRADA', observacao: 'Estorno (desfazer devolução)' };
              registrarAcao('chaves', 'devolver_clicou', 'chave'); registrarResultado('chaves', 'devolver_clicou', 'ok');
              toast('Chave devolvida!', 'sucesso', { rotulo: 'Desfazer', ttl: 7000, onAcao: () => desfazer(inverso) });
              await carregar();
              return true;
            },
          },
        ],
      });
    }

    async function desfazer(mov) {
      const { erro } = await registrarMovimentacao(mov);
      if (erro) { toast(erro, 'erro'); return; }
      toast('Desfeito.', 'info');
      await carregar();
    }

    estado.motivos = await listarMotivos();
    carregar();
    assinarTabela('chave', recarregarSilencioso);
    pollPeriodico(recarregarSilencioso);
  },
};

/** Seletor de colaborador com busca (debounce) e teclado (setas + Enter). Editar o texto zera a seleção. */
function pickerColaborador(inicial) {
  let selecionado = null;
  let itens = [];
  let ativo = -1;
  const input = el('input', { type: 'text', placeholder: 'Buscar nome, CPF ou matrícula…' });
  const lista = el('div', { class: 'mov-picker__lista' });
  const limpar = el('button', { type: 'button', class: 'input-x', tabindex: '-1', title: 'Limpar', 'aria-label': 'Limpar', onMousedown: (e) => { e.preventDefault(); selecionado = null; input.value = ''; wrap.classList.remove('mov-picker--ok'); limpar.style.display = 'none'; fecharLista(); input.focus(); } }, [el('i', { class: 'ph ph-x' })]);
  const campoInput = el('div', { class: 'mov-picker__campo' }, [input, limpar]); // input+X juntos: o X ancora so no input, nao segue o dropdown
  const wrap = el('div', { class: 'mov-picker' }, [campoInput, lista]);
  limpar.style.display = 'none';
  let timer = null;

  const fecharLista = () => { lista.style.display = 'none'; ativo = -1; };
  function selecionar(c) {
    selecionado = c;
    input.value = `${formatarNome(c.nome)}${c.empregador?.empresa ? ' · ' + empresaCurta(c.empregador.empresa) : ''} (${rotuloDocumento(c)})`;
    wrap.classList.add('mov-picker--ok');
    limpar.style.display = '';
    fecharLista();
  }
  function destacar(i) {
    ativo = i;
    [...lista.children].forEach((n, k) => n.classList.toggle('mov-picker__item--ativo', k === i));
    lista.children[i]?.scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('input', () => {
    selecionado = null;
    wrap.classList.remove('mov-picker--ok');
    limpar.style.display = input.value ? '' : 'none';
    clearTimeout(timer);
    const termo = input.value.trim();
    timer = setTimeout(async () => {
      itens = await buscarColaboradores(termo);
      clear(lista);
      if (!itens.length) { fecharLista(); return; }
      itens.forEach((c, i) => {
        const susp = !!c.acesso_suspenso;
        lista.append(el('div', {
          class: 'mov-picker__item',
          onMouseenter: () => destacar(i),
          onClick: () => selecionar(c),
        }, [
          el('span', { text: `${formatarNome(c.nome)}${c.empregador?.empresa ? ' · ' + empresaCurta(c.empregador.empresa) : ''} · ${rotuloDocumento(c)}` }),
          c.homonimo ? el('span', { style: 'color:var(--amarelo);font-weight:600', text: ' · ⚠ nome repetido' }) : null,
          susp ? el('span', { style: 'color:var(--amarelo);font-weight:600', text: ' · afastado' }) : null,
        ]));
      });
      lista.style.display = 'block';
      destacar(0);
    }, 250);
  });

  input.addEventListener('keydown', (e) => {
    const aberta = lista.style.display === 'block' && itens.length;
    if (e.key === 'ArrowDown' && aberta) { e.preventDefault(); destacar(Math.min(ativo + 1, itens.length - 1)); }
    else if (e.key === 'ArrowUp' && aberta) { e.preventDefault(); destacar(Math.max(ativo - 1, 0)); }
    else if (e.key === 'Enter' && aberta && ativo >= 0) { e.preventDefault(); e.stopPropagation(); selecionar(itens[ativo]); }
    else if (e.key === 'Escape' && aberta) { e.preventDefault(); e.stopPropagation(); fecharLista(); }
  });

  if (inicial && inicial.id) selecionar(inicial);
  return { elemento: wrap, getSelecionado: () => selecionado };
}



















